var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4761 6.55077L10.9888 6.49622L10.6663 15.3017L12.1536 15.356L12.4761 6.55077Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59916 6.52349H8.11093V15.329H9.59916V6.52349Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04362 15.3014L6.72118 6.49595L5.23391 6.55054L5.55639 15.356L7.04362 15.3014Z",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.85249V4.34072H1.55076L2.78101 18.3211C2.81475 18.7053 3.13648 19 3.52216 19H14.1629C14.5486 19 14.8706 18.7051 14.9041 18.3209L16.1343 4.34072H17.7102V2.85249H0ZM13.4813 17.5118H4.20356L3.04471 4.34072H14.6404L13.4813 17.5118Z",
    fill: "#979797"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2859 0H6.4243C5.74045 0 5.1841 0.556344 5.1841 1.2402V3.5966H6.67234V1.48823H11.0379V3.5966H12.5261V1.2402C12.5261 0.556344 11.9698 0 11.2859 0Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.fadd32e89f6e853f71c47e97331903f2.svg";
export { ForwardRef as ReactComponent };